module.exports = __webpack_public_path__ + "static/media/service-app-development.d6374b7c.png";